import React from 'react';
import { Checkbox, CheckboxProps, FormControlLabel, FormHelperText } from '@material-ui/core';
import Field, { FieldProps } from './Field';

type CheckboxFieldProps<P> = Omit<FieldProps<P, CheckboxProps>, 'renderer'>;

const CheckboxWithLabel = ({ label, error, helpertext, ...other }: any) => {
    return (
        <>
            <FormControlLabel
                control={<Checkbox color='primary' {...other} />}
                label={label}
            />
            {error && <FormHelperText error>{helpertext}</FormHelperText>}
        </>
    );
};

export const CheckboxField = <P,>(props: CheckboxFieldProps<P>) => (
    <Field
        type="checkbox"
        renderer={CheckboxWithLabel}
        {...props}
    />
);
